/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const RoundRobinType = {
    SINGLE: 'SINGLE',
    DOUBLE: 'DOUBLE'
} as const;
export type RoundRobinType = typeof RoundRobinType[keyof typeof RoundRobinType];


export function instanceOfRoundRobinType(value: any): boolean {
    for (const key in RoundRobinType) {
        if (Object.prototype.hasOwnProperty.call(RoundRobinType, key)) {
            if (RoundRobinType[key as keyof typeof RoundRobinType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function RoundRobinTypeFromJSON(json: any): RoundRobinType {
    return RoundRobinTypeFromJSONTyped(json, false);
}

export function RoundRobinTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): RoundRobinType {
    return json as RoundRobinType;
}

export function RoundRobinTypeToJSON(value?: RoundRobinType | null): any {
    return value as any;
}

export function RoundRobinTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): RoundRobinType {
    return value as RoundRobinType;
}

